$R.addLang('fr', {
    'align': 'Alignement',
    'align-left': 'Gauche',
    'align-center': 'Centrer',
    'align-right': 'Droite',
    'align-justify': 'Justifié'
});